import { API_V1 } from 'API/APIs/APIv1';
import _ from 'lodash';
import Logger from 'logger';

export const getLinkedinLocationsWithCookies = async (query: string, lang: string, liAtCookie?: string, sessionCookie?: string) => {
  try {
    const response = await API_V1.post(
      '/linkedin/lookups/geo',
      {
        liAtCookie: liAtCookie && liAtCookie !== '' ? liAtCookie : undefined,
        sessionCookie: sessionCookie && sessionCookie !== '' ? sessionCookie : undefined,
      },
      {
        params: {
          query,
          lang,
        },
      }
    );

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting LinkedIn geo locations!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getLinkedinLocations = async (query: string, lang: string, linkedinAccount: string | undefined) => {
  try {
    const response = await API_V1.post(
      '/linkedin/lookups/geo',
      {
        linkedinAccount,
      },
      {
        params: {
          query,
          lang,
        },
      }
    );

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting LinkedIn geo locations!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getPostalCodeLocation = async (postalCode: string, linkedinAccount: string | undefined) => {
  try {
    const response = await API_V1.post('/linkedin/lookups/geo/postal-code', {
      postalCode,
      linkedinAccount,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting postal code location!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
